import { graphql } from '../gql';

const GET_COMMUNITY_LIST = graphql(`
  query CommunitiesQuery {
    communities {
      id
      name
      url
      description
      imageUrl
      usersCount
    }
  }
`);

const GET_COMMUNITY_BY_URL = graphql(`
  query CommunityQuery($url: String!) {
    community(url: $url) {
      id
      name
      url
      description
      imageUrl
      usersCount
      postsCount
      isMember
      shortUsersList {
        id
        email
        role
        name
        profileImage
      }
    }
  }
`);

const SYNC_USER = graphql(`
  mutation SyncUser {
    syncUser {
      email
      id
      name
      role
      profileImage
      isBanned
    }
  }
`);

const JOIN_USER_TO_COMMUNITY = graphql(`
  mutation JoinCommunity($communityId: Int!) {
    joinCommunity(communityId: $communityId) {
      id
    }
  }
`);

const LEAVE_USER_FROM_COMMUNITY = graphql(`
  mutation LeaveCommunity($communityId: Int!) {
    leaveCommunity(communityId: $communityId) {
      id
    }
  }
`);

const GET_POSTS_LIST = graphql(`
  query PostsQuery($offset: Int!, $limit: Int!, $communityUrl: String, $excludePostIds: [Int!], $sortBy: PostSortBy!) {
    postCount(communityUrl: $communityUrl, deleted: false)
    posts(
      offset: $offset
      limit: $limit
      communityUrl: $communityUrl
      excludePostIds: $excludePostIds
      sortBy: $sortBy
      deleted: false
    ) {
      id
      title
      content
      createdAt
      commentsCount(topLevelOnly: true)
      isFlaggedByCurrentUser
      author {
        id
        name
        profileImage
        role
      }
      community {
        id
        name
        url
        imageUrl
        isMember
      }
      reactionsSummary {
        reaction
        count
        isAddedByCurrentUser
      }
    }
  }
`);

const GET_DELETED_POST_LIST = graphql(`
  query DeletedPostList($offset: Int!, $limit: Int!, $sortBy: PostSortBy!) {
    postCount(deleted: true)
    posts(offset: $offset, limit: $limit, deleted: true, sortBy: $sortBy) {
      id
      title
      content
      createdAt
      deletedAt
      author {
        id
        name
        profileImage
        role
      }
      community {
        id
        name
        url
      }
    }
  }
`);

const GET_PREVIOUSLY_VIEWED_POSTS = graphql(`
  query PreviouslyViewedPosts($offset: Int!, $limit: Int!, $postIds: [Int!]!) {
    posts(offset: $offset, limit: $limit, postIds: $postIds) {
      id
      content
      author {
        id
        name
      }
      community {
        id
        name
        url
      }
    }
  }
`);

const GET_POST_BY_ID = graphql(`
  query PostQuery($id: Int!, $communityUrl: String!) {
    post(id: $id, communityUrl: $communityUrl) {
      id
      title
      content
      commentsCount(topLevelOnly: true)
      createdAt
      isFlaggedByCurrentUser
      author {
        id
        name
        profileImage
        role
      }
      community {
        id
        name
        url
        imageUrl
        isMember
      }
      reactionsSummary {
        reaction
        count
        isAddedByCurrentUser
      }
    }
  }
`);

const GET_COMMUNITY_MEMBERS = graphql(`
  query CommunityMembersQuery($communityId: Int!, $skipCurrentUser: Boolean, $offset: Int!, $limit: Int!) {
    members(communityId: $communityId, skipCurrentUser: $skipCurrentUser, offset: $offset, limit: $limit) {
      id
      email
      role
      name
      profileImage
    }
  }
`);

const CREATE_POST = graphql(`
  mutation AddPost($communityId: Int!, $postContent: String!) {
    createPost(communityId: $communityId, postContent: $postContent) {
      id
      title
      content
      createdAt
      commentsCount(topLevelOnly: true)
      isFlaggedByCurrentUser
      author {
        id
        name
        profileImage
        role
      }
      community {
        id
        name
        url
        imageUrl
        isMember
      }
      reactionsSummary {
        reaction
        count
        isAddedByCurrentUser
      }
    }
  }
`);

const ADD_POST_REACTION = graphql(`
  mutation AddPostReaction($reaction: Int!, $postId: Int!) {
    addPostReaction(reaction: $reaction, postId: $postId) {
      id
    }
  }
`);

const REMOVE_POST_REACTION = graphql(`
  mutation RemovePostReaction($reaction: Int!, $postId: Int!) {
    removePostReaction(reaction: $reaction, postId: $postId)
  }
`);

const GET_POST_REACTIONS = graphql(`
  query GetPostReactions($postId: Int!, $offset: Int!, $limit: Int!, $reaction: Int) {
    getPostReactions(postId: $postId, offset: $offset, limit: $limit, reaction: $reaction) {
      id
      reaction
      author {
        id
        name
        profileImage
      }
    }
  }
`);

const DELETE_POST = graphql(`
  mutation DeletePost($postId: Int!) {
    deletePost(postId: $postId) {
      id
    }
  }
`);

const REPUBLISH_POST = graphql(`
  mutation RepublishPost($postId: Int!) {
    republishPost(postId: $postId) {
      id
    }
  }
`);

const GET_MOST_ACTIVE_USERS = graphql(`
  query MostActiveUsers($limit: Int) {
    mostActiveUsers(limit: $limit) {
      id
      email
      role
      name
      profileImage
    }
  }
`);

const communityForumServices = {
  GET_COMMUNITY_LIST,
  GET_COMMUNITY_BY_URL,
  SYNC_USER,
  JOIN_USER_TO_COMMUNITY,
  LEAVE_USER_FROM_COMMUNITY,
  GET_POSTS_LIST,
  GET_DELETED_POST_LIST,
  GET_PREVIOUSLY_VIEWED_POSTS,
  GET_POST_BY_ID,
  GET_COMMUNITY_MEMBERS,
  CREATE_POST,
  ADD_POST_REACTION,
  REMOVE_POST_REACTION,
  GET_POST_REACTIONS,
  DELETE_POST,
  REPUBLISH_POST,
  GET_MOST_ACTIVE_USERS,
};

export default communityForumServices;
